angular.module('impactx.combibudget').service('CombiBudgetService', CombiBudgetService);

CombiBudgetService.$inject = ['$mdDialog', '$redirect'];

function CombiBudgetService($mdDialog, $redirect)
{
    function openDecideDialog(ctuId, usrId) {
        $mdDialog.show({
            controller: 'CombiBudgetDecideController',
            controllerAs: 'combiBudgetDecideController',
            templateUrl: 'modules/combibudget/templates/combibudgetdecide.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                ctuId: ctuId
            }
        }).then(function(answer) {
            if (answer) {
                $redirect.redirectTo(null, "/combibudget/edit/" + answer.ctuId + "/" + answer.modeSelection.setId + "/" + usrId);
            }
        });
    }

    return {
        openDecideDialog: openDecideDialog
    };
}